import { useQuery } from "src/Hooks/useReactQuery";
import { getUserList } from "src/services/auth";

const useUserList = (
  arrayOutput = false
) => {
  const { data, isLoading, isError, error } = useQuery(
    ["userList"],
    () => getUserList(),
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchInterval: 0,
      retry: 0,
      networkMode: "always",
      select: (data) => {
        if (arrayOutput) {
          return data?.items?.map(user => ({
            label: user.name,
            value: user.id,
          })) || [];
        }
        return data?.items?.reduce((acc, user) => {
          acc[user.id] = user.name;
          return acc;
        }, {});
      },
    },
  );

  return { data, isLoading, isError, error };
};

export default useUserList;